import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputDate from 'modules/_shared/components/InputDate';
import UploadDocument from 'modules/documents/components/UploadDocument';
import InputTextArea from 'modules/_shared/components/InputTextArea';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsDistributionModalScriptureView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDividendsDistributionModal();

  return (
    <>
      <InputDate
        id="date"
        label={t('Date')}
        value={data.date || ''}
        onChange={actions.handleChangeDate}
        minDate={data.lastOperationDate}
        errorMessageKey="InvalidOperationDate"
        required
        lgSize
      />

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        noResize
      />
    </>
  );
};

export default DividendsDistributionModalScriptureView;
